const perfilferricoModel = () => {
  return {
    ferrit: {
      value: "",
      unit: "",
    },
    transfer: {
      value: "",
      unit: "",
    },
    satTransfer: {
      value: "",
      unit: "",
    },
    tibc: {
      value: "",
      unit: "",
    },
    fe: {
      value: "",
      unit: "",
    },
  };
};

const um = () => {
  return {
    ferrit: ["ng/mL"],
    transfer: ["mg/dL"],
    satTransfer: ["%"],
    tibc: ["mcg/dL", "mcmol/L"],
    // Bug real (auditoría 2026-08-16): "mcg/L" no es una unidad SI alternativa válida para
    // hierro sérico (µg/dL vs µg/L difieren x10, no son el mismo valor en otra unidad) — todos
    // los demás pares del archivo son [unidad_másica, unidad_molar] (ver "tibc" arriba, que
    // además se extrae junto con "fe" en el mismo perfil). Se corrige a la unidad molar SI.
    fe: ["mcg/dL", "mcmol/L"],
  };
};

export { perfilferricoModel, um };
